import * as React from 'react';
import { useState } from 'react';
import { toast } from 'react-toastify';

import { ConfirmationModal } from './ConfirmationModal';
import { axios } from '../api';
import { Pencil } from '../assets/Pencil';
import { isAdmin, isAllModuleAccessUser, isOpsAdmin } from '../pages/constants';
import { BOTTOM_TOAST, generateErrorMsg } from '../utils';

interface SwitchPaymentProcessorProps {
  customer_id: string;
  setPrimaryPaymentProcessor: (processor: string) => void;
  primaryPaymentProcessor: string;
}

export const SwitchPaymentProcessor = ({
  customer_id,
  primaryPaymentProcessor,
  setPrimaryPaymentProcessor,
}: SwitchPaymentProcessorProps) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const hasPermission = isAdmin() || isOpsAdmin() || isAllModuleAccessUser();

  const handleSwitchPaymentProcessor = () => {
    axios
      .post(`payment_methods/switch_payment_processor`, {
        account_id: customer_id,
      })
      .then((response) => {
        setPrimaryPaymentProcessor(response.data.new_payment_processor);
        toast.success(
          `Success! The customer was able to add a credit card through the portal.`,
          BOTTOM_TOAST
        );
      })
      .catch((e) => {
        toast.error(generateErrorMsg(e), BOTTOM_TOAST);
      });
    setShowConfirmModal(false);
  };
  if (customer_id) {
    return (
      <div className="flex justify-between items-center">
        {hasPermission && primaryPaymentProcessor === 'BRAINTREE' && (
          <Pencil
            className="w-4 h-4 mx-1 text-black cursor-pointer"
            onClick={() => setShowConfirmModal(true)}
          />
        )}
        {showConfirmModal && (
          <ConfirmationModal
            title="Are you sure you want to switch this customer’s payment processor from Braintree/PayPal to Stripe?"
            customMessage={
              <div>
                <p className="text-sm mb-4 text-center text-red-600">
                  Please note that this action is irreversible.
                </p>
              </div>
            }
            confirmLabel="Switch Payment Processor"
            onConfirm={handleSwitchPaymentProcessor}
            onCancel={() => setShowConfirmModal(false)}
          />
        )}
      </div>
    );
  }
};
